export const routes = [
  {
    path: '/gerenciar-meus-dados',
    component: () => import(/* webpackChunkName: "admin" */ './Index.vue')
  },
  {
    path: '/admin',
    component: () =>
      import(/* webpackChunkName: "admin" */ './components/DashboardLog.vue')
  },
  {
    path: '/admin/chamadas-publicas',
    component: () =>
      import(
        /* webpackChunkName: "admin" */ './components/AdministracaoChamadaPublica.vue'
      )
  }
]
